import React from 'react';
import PropTypes from 'prop-types'
import LoadingSpinner from './LoadingSpinner';

const propTypes = {};
const defaultProps = {};

class LoadingMainContent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            show: false,
            timerID: null
        };

        this.show = this.show.bind(this);
    }

    componentDidMount() {
        const self = this;
        this.setState({ timerID: window.setTimeout(self.show, 200) });
    }

    componentWillUnmount() {
        if (this.state.timerID) {
            window.clearTimeout(this.state.timerID);
        }
    }

    show() {
        this.setState({ show: true, timerID: null });
    }

    render(){
        return (
            <div className="loading-list">
                {this.state.show &&
                    <LoadingSpinner />
                }
            </div>
        )
    }
}

LoadingMainContent.propTypes = propTypes;
LoadingMainContent.defaultProps = defaultProps;

export default LoadingMainContent;
